import { useState, useContext, useEffect } from 'react'
import Input from '../../Input'
import "./style.scss"
import { AuthContext } from '../../../context/auth';
import { getTemplatesApi, getTemplatesCategoriesApi } from '../../../api';
import Dropdown from '../../Dropdown';

const Index = ({
  setShowTemplateModal,
  setSavedPosition,
  onInsertTemplate
}) => {
const { setNotification, setIsLoading, isLoading } = useContext(AuthContext);
const [selectedCategory, setSelectedCategory] = useState(null)
const [templatesOptions, setTemplatesOptions] = useState([])
const [templates, setTemplates] = useState([])
const [template, setTemplate] = useState(null)
const [templateCategories, setTemplatesCategories] = useState([])

const predefinedCategories = {
  "Microscope Description": "Microscope Descriptions",
  "Image Size": "Image Size & Dimensions",
  "Lattice SIM": "Lattice SIM Channels",
  "Airyscan": "Airyscan Channels",
  "Confocal": "Confocal Channels",
  "Widefield SIM": "Widefield SIM Channels",
  "Widefield": "Widefield Channels",
  "Post Processing": "Post Processing",
  "Image Correction": "Image Corrections",
  "Signature": "Signatures",
  "SR SIM": "SR SIM Channels",
  "SR SIM2": "SR SIM2 Channels",
  "Method": "Methods",
};

const fetchTemplatesCategories = () => {
    setIsLoading(true)
    getTemplatesCategoriesApi().then(res => {
      if (res && res.data) {
        const categories = res?.data?.templatesCategories
        const staticCategories = Object.values(predefinedCategories).map((category, index) => ({ name: category, id: index }))
        setTemplatesCategories([...categories, ...staticCategories])
        setIsLoading(false)
      }
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
}

const categorized = (data) => {
return data.map(item => {
  const name = item.name.trim();
  const category = Object.keys(predefinedCategories).find(prefix => name.startsWith(prefix)) || "Other";
  return {
    ...item,
    category: predefinedCategories[category] || "Other"
  };
})
}

  const getTemplates = () => {
    setIsLoading(true)
    getTemplatesApi().then(res => {
      if (res && res.data) {
        const templates = res?.data?.templates?.sort((a, b) => a.name.localeCompare(b.name)) || []
        setTemplatesOptions(categorized(templates))
        setIsLoading(false)
      }
    }).catch(err => {
      setIsLoading(false)
      setNotification({
        message: "Something went wrong.",
        type: "red"
      })
    })
  }

  useEffect(() => {
    getTemplates()
    fetchTemplatesCategories()
  }, [])

  useEffect(() => {
    if (selectedCategory) {
      const id = typeof selectedCategory?.id === 'string' ? selectedCategory?.id : null;
      const filteredTemplates = templatesOptions?.filter((item) => item?.category === selectedCategory?.name)
      setTemplates(id ? selectedCategory?.templates : filteredTemplates)
    }
  }, [selectedCategory])

  return (
    <div className="small-modal-wrapper">
        <div className="editor-modal-content">
        <i className='fal fa-times close' style={{ color: '#9a9a9a', position: 'absolute', right: '15px', top: '12px', cursor: 'pointer', zIndex: 9, fontSize: '20px' }} onClick={() => {
          setShowTemplateModal(false)
          setSavedPosition(null)
        }}></i>
        <span style={{ width: '44px', height: '44px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#DC1E00', color: 'var(--white)' }}>
            <i class="fal fa-list-alt" style={{fontWeight:'300' }}></i>
            </span>
            <h2>Select Predefined Template</h2>
              <div className="input-container">
                <Dropdown label="Select Template Category" options={templateCategories} value={selectedCategory} onChange={(value) => setSelectedCategory(value)} className={'dropdown'} optionType='role' searchable />
              </div>
            {selectedCategory &&
            <div className='templates'>
              {
              templates?.length > 0 ?
                templates.map((item) => {
                  return (
                      <div className="radio-wrapper">
                      <Input checked={item?.id === template?.id} radio value={item?.name} name="template" onChange={() => setTemplate(item)} className={item?.id === template?.id ? 'active-radio radio-containers' : 'radio-containers'} />
                    </div>
                  )
                })
                :
                <h4>No templates found</h4>
              }
            </div>
            }
            <button className='btn' style={{background: 'var(--primary-color)', color: 'var(--white)'}} 
                disabled={!template || isLoading}
                onClick={() => {
                onInsertTemplate(template?.template)
                setShowTemplateModal(false)
                setSavedPosition(null)
            }}>Add Template</button>
            <button className='btn transparent' onClick={() => {
                setShowTemplateModal(false)
                setSavedPosition(null)
            }}>Cancel</button>
        </div>
    </div>
  )
}

export default Index